import { isMobile } from './HTMLutils'

var timer: any = null
export const scrollSmooth = (options: {
  top: number
  left: number
  duration: number
  element?: any
  behavior?: 'smooth'
}) => {
  if (isMobile()) {
    smoothScrollTo(options.left, options.top, options.duration, options.element)
  } else if (options.element) {
    options.element.scrollTo(options)
  } else {
    window.scrollTo(options)
  }
}

function smoothScrollTo(
  endX: number,
  endY: number,
  duration: number,
  element?: any
) {
  if (element) element.style.scrollSnapType = 'none'
  const startX = element
    ? element.scrollLeft
    : window.scrollX || window.pageXOffset
  const startY = element
    ? element.scrollTop
    : window.scrollY || window.pageYOffset
  const distanceX = endX - startX
  const distanceY = endY - startY
  const startTime = new Date().getTime()

  duration = typeof duration !== 'undefined' ? duration : 400

  // Easing function
  const easeInOutQuart = (
    time: number,
    from: number,
    distance: number,
    duration: number
  ) => {
    if ((time /= duration / 2) < 1)
      return (distance / 2) * time * time * time * time + from
    return (-distance / 2) * ((time -= 2) * time * time * time - 2) + from
  }

  if (timer) {
    clearInterval(timer)
    timer = null
  }
  timer = setInterval(() => {
    const time = new Date().getTime() - startTime
    const newX = easeInOutQuart(time, startX, distanceX, duration)
    const newY = easeInOutQuart(time, startY, distanceY, duration)
    if (time > duration) {
      clearInterval(timer)
      setTimeout(() => {
        if (element) element.style.scrollSnapType = ''
      }, 50)
    } else if (element) {
      element.scroll(newX, newY)
    } else {
      window.scroll(newX, newY)
    }
  }, 1000 / 60) // 60 fps
}
